"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputGroup = _interopRequireDefault(require("../FormControlFragments/InputGroup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxGroup = function CheckboxGroup(_ref) {
  var checkboxItems = _ref.checkboxItems,
      classes = _ref.classes,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      errorMessages = _ref.errorMessages,
      groupFormControlId = _ref.groupFormControlId,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isValid = _ref.isValid,
      legendLabel = _ref.legendLabel;
  return /*#__PURE__*/_react.default.createElement(_InputGroup.default, {
    classes: classes,
    description: description,
    descriptionId: descriptionId,
    errorMessages: errorMessages,
    groupFormControlId: groupFormControlId,
    groupedItems: checkboxItems,
    isCheckboxGroup: true,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isValid: isValid,
    legendLabel: legendLabel
  });
};

CheckboxGroup.propTypes = {
  /**
   Required. The list of Checkbox Items, objects with props from Checkbox component.
   */
  checkboxItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    handleOnChange: _propTypes.default.func,
    label: _propTypes.default.string
  })).isRequired,

  /**
   Optional. Custom group container styles.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Custom description of input group. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. Custom ID for description of input group.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. Custom ID for Checkbox Group container.
   */
  groupFormControlId: _propTypes.default.string,

  /**
   Optional. Used to pass HTML in the description prop. Defaults false.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
    Optional. Defaults false.
    */
  isDisabled: _propTypes.default.bool,

  /**
    Optional. Defaults true.
    */
  isValid: _propTypes.default.bool,

  /**
   Required. Legend text or description need to be used to properly group the fields.
   */
  legendLabel: _propTypes.default.string.isRequired
};
CheckboxGroup.defaultProps = {
  classes: '',
  description: '',
  descriptionId: '',
  errorMessages: [],
  groupFormControlId: '',
  isDescriptionHtml: false,
  isDisabled: false,
  isValid: true
};
var _default = CheckboxGroup;
exports.default = _default;